// Visualizador de fotos em tela cheia da PDP: a lupa de cada foto abre o <dialog> já na foto
// clicada; arrastar/setas trocam de foto e um toque aproxima (2.2x) no ponto tocado.
(() => {
  const boot1 = (scope = document) =>
    scope.querySelectorAll('[data-zoom-dialog]').forEach((dialog) => {
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';

    const root = dialog.closest('[data-product]') || document;
    const track = dialog.querySelector('[data-zoom-track]');
    const slides = Array.from(track.children);
    const counter = dialog.querySelector('[data-zoom-counter]');

    const currentIndex = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    const resetZoom = () => {
      track.querySelectorAll('img.is-zoomed').forEach((img) => img.classList.remove('is-zoomed'));
    };
    const goTo = (index, behavior = 'smooth') => {
      const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (target) track.scrollTo({ left: target.offsetLeft, behavior });
    };

    root.querySelectorAll('[data-zoom-open]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        goTo(Number(button.dataset.zoomIndex) || 0, 'instant');
      });
    });

    dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      resetZoom();
      document.documentElement.style.overflow = '';
    });

    const prev = dialog.querySelector('[data-zoom-prev]');
    const next = dialog.querySelector('[data-zoom-next]');
    if (prev) prev.addEventListener('click', () => goTo(currentIndex() - 1));
    if (next) next.addEventListener('click', () => goTo(currentIndex() + 1));

    let scrollTimer;
    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          resetZoom();
          if (counter) counter.textContent = `${currentIndex() + 1} / ${slides.length}`;
        }, 80);
      },
      { passive: true }
    );

    track.addEventListener('click', (event) => {
      const img = event.target.closest('img');
      if (!img) return;
      if (img.classList.contains('is-zoomed')) {
        img.classList.remove('is-zoomed');
        return;
      }
      const rect = img.getBoundingClientRect();
      img.style.transformOrigin = `${((event.clientX - rect.left) / rect.width) * 100}% ${((event.clientY - rect.top) / rect.height) * 100}%`;
      img.classList.add('is-zoomed');
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') goTo(currentIndex() - 1);
      if (event.key === 'ArrowRight') goTo(currentIndex() + 1);
    });
  });
  boot1();
  document.addEventListener('shopify:section:load', (event) => boot1(event.target));
})();
